import { localKeyInfo } from '@/views/Voice/store/config';
import store from '@/store/index';
import LocalStore from '@/utils/store';
import { joinroom, getRoomDetail, leaveroom, findRandomLiveRoom } from './server';
import { setLeftInfo } from '@/views/Voice/store/module/voiceLeft';
import { setRoomInfo } from '@/views/Voice/store/module/roomInfo';
import { setMsgInfo } from '@/views/Voice/store/module/msgInfo';
import { setKickInfo } from '@/views/Voice/store/module/kickInfo';
import { setOnlineInfo } from '@/views/Voice/store/module/onlineInfo';
import { setValidateInfo } from '@/views/Voice/store/module/validateInfo';
import { toLogout } from '@/views/Voice/voiceMain/myRoom/chatRoom/WebIM';
import { message } from 'antd';
import { destroyRtc } from './voiceMain/myRoom/controlBar/rightInfo/boxRtc';

interface NewEnterVoiceRoomParams {
  roomId: number;
  isMain?: boolean;
  noCheck?: boolean;
  livePlatform?: string;
  collectType?: number;
}

const VoiceFn = {
  getLocalInfo: (strKey: string) => {
    const info: any = LocalStore.getValue(localKeyInfo[strKey]);
    return info;
  },
  convertParams: (method: string, info: any) => {
    if (info) {
      const data = typeof info === 'string' ? JSON.parse(info) : JSON.parse(JSON.stringify(info));
      const roomInfo = VoiceFn.getLocalInfo('roomInfo');
      if (data && data.fromType !== undefined && data.roomId !== undefined) {
        if (!data?.live_platform) {
          data.live_platform = VoiceFn.getVoiceLivePlatform();
        }
        if (roomInfo && roomInfo.mainRoomId) {
          const localFromType = LocalStore.getValue('VOICE_REQUEST_ROOMMAIN', 0);
          if (localFromType) {
            data.fromType = localFromType === 1 ? 0 : 3;
            LocalStore.removeValue('VOICE_REQUEST_ROOMMAIN');
          } else {
            if (roomInfo.mainRoomId !== data.roomId) {
              data.fromType = 3;
            }
          }
        }
      }
      return data;
    }
    return info;
  },
  // import VoiceFn from '@/views/Voice/fn';
  setVoiceLivePlatform: (platform?: string) => {
    localStorage.setItem('VOICEROOM_PLATFORM', platform ?? '996box');
  },
  removeVoiceLivePlatform: () => {
    localStorage.removeItem('VOICEROOM_PLATFORM');
  },
  getVoiceLivePlatform: () => {
    const platform = localStorage.getItem('VOICEROOM_PLATFORM');
    return platform ?? '996box';
  },
  resolveVoiceLivePlatform: (platform?: string) => {
    return platform ?? '996box';
  },
  cancelLoading: (reloadTime: number) => {
    try {
      const leftInfo = VoiceFn.getLocalInfo('leftInfo');
      store.dispatch(
        setLeftInfo({
          ...leftInfo,
          reloadTime
        })
      );
    } catch (error) {
      console.log(error);
    }
  },
  getRoomInfo: async (roomId: number) => {
    roomId = typeof roomId === 'number' ? roomId : Number(roomId);
    try {
      const info: any = LocalStore.getValue('React-ant-Admin-user');
      const { data } = await getRoomDetail({
        roomId,
        fromType: 0,
        userId: info.userinfo.id
      });
      const date: any = new Date();
      const dateNum = parseInt((date / 1000).toString());
      const diffTime = data.systemTime - dateNum;
      const roomInfo = VoiceFn.getLocalInfo('roomInfo');
      store.dispatch(
        setRoomInfo({
          ...roomInfo,
          mainRoomInfo:
            roomId === roomInfo.mainRoomId
              ? {
                  id: data.roomId,
                  roomId: data.roomId,
                  showRoomId: data.showRoomId,
                  roomName: data.roomName,
                  totalNum: data.audienceNum,
                  logoUrl: data.logoUrl,
                  typeId: data.typeId,
                  isAllBanned: data.isAllBanned === 0 || data.isAllBanned === 1 ? true : false,
                  imId: data.imId,
                  gameName: data.gameName,
                  serverName: data.serverName,
                  typeName: data.typeName
                }
              : roomInfo.mainRoomInfo,
          roomId: data.roomId,
          roleId: data.roleId === null || undefined ? 3 : data.roleId,
          modelType: data.modelType,
          roomNum: data.audienceNum,
          diffTime,
          micStatus: data.micStatus,
          isMic: data.onMic,
          isAllBanned: data.isAllBanned === 0 || data.isAllBanned === 1 ? true : false,
          banMsg: data.isBanned,
          roomDetail: data,
          hxRoomId: Number(data.imId),
          chatInterval: Number(data.chatInterval || 0),
          tourBanChat: data.tourBanChat ? JSON.parse(data.tourBanChat) : false,
          svip_effect: data.svip_effect,
          userId: data.userId,
          ctime: data.systemTime, // 进入房间时间
          user_96show: data?.user_96show
        })
      );
      VoiceFn.cancelLoading(0);
    } catch (error) {
      console.log(error);
    }
  },
  toEnterRoom: async (roomId: number, isMain?: boolean, isShowRoom?: boolean, livePlatform?: string) => {
    VoiceFn.cancelLoading(Date.now());
    roomId = typeof roomId === 'number' ? roomId : Number(roomId);
    try {
      const leftInfo = VoiceFn.getLocalInfo('leftInfo');
      const roomInfo = VoiceFn.getLocalInfo('roomInfo');
      store.dispatch(
        setMsgInfo({
          msgItem: undefined
        })
      );
      if (isMain && roomInfo && roomInfo.roomId && roomInfo.mainRoomId && roomId === roomInfo.mainRoomId) {
        store.dispatch(
          setLeftInfo({
            ...leftInfo,
            showComId: 'myRoom'
          })
        );
        VoiceFn.cancelLoading(0);
      } else if (isMain && roomInfo && roomInfo.mainRoomId && roomInfo.mainRoomId !== roomId) {
        try {
          VoiceFn.toLeaveRoom(true);
        } catch (error) {
          VoiceFn.cancelLoading(0);
        }
        setTimeout(() => {
          VoiceFn.toEnterRooms(roomId, isMain, isShowRoom, livePlatform);
        }, 1000);
      } else if (!isMain && roomInfo && roomInfo.mainRoomId) {
        try {
          const joinConflict = localStorage.getItem('BOXANDSHOW');
          const info: any = LocalStore.getValue('React-ant-Admin-user');
          await leaveroom({
            roomId: roomInfo.roomId,
            fromType: 0,
            userId: info.userinfo.id,
            live_platform: livePlatform,
            quitType: joinConflict ? JSON.parse(joinConflict) : ''
          });
          if (isMain) {
            store.dispatch(
              setRoomInfo({
                ...roomInfo,
                mainRoomInfo: isMain
                  ? {
                      ...roomInfo.mainRoomInfo,
                      id: roomId,
                      roomId
                    }
                  : undefined,
                mainRoomId: isMain ? roomId : 0
              })
            );
          }
          setTimeout(() => {
            VoiceFn.toEnterRooms(roomId, isMain, isShowRoom, livePlatform);
          }, 600);
        } catch (error) {
          VoiceFn.cancelLoading(0);
        }
      } else {
        VoiceFn.toEnterRooms(roomId, isMain, isShowRoom, livePlatform);
      }
    } catch (error) {
      console.log(error);
      VoiceFn.cancelLoading(0);
    }
  },
  toEnterRooms: async (roomId: number, isMain?: boolean, isShowRoom?: boolean, livePlatform?: string) => {
    try {
      const leftInfo = VoiceFn.getLocalInfo('leftInfo');
      const roomInfo = VoiceFn.getLocalInfo('roomInfo');
      const info: any = LocalStore.getValue('React-ant-Admin-user');
      const objInfo: any = {
        roomId,
        showRoomId: roomId,
        fromType: 0,
        userId: info.userinfo.id,
        live_platform: livePlatform
      };
      if (isShowRoom) {
        delete objInfo.roomId;
      } else {
        delete objInfo.showRoomId;
      }
      const res: any = await joinroom(objInfo);
      if (res.code === 200) {
        VoiceFn.setVoiceLivePlatform(livePlatform);
        const data = res.data;
        store.dispatch(
          setLeftInfo({
            ...leftInfo,
            showComId: 'myRoom',
            reloadTime: Date.now()
          })
        );
        store.dispatch(
          setRoomInfo({
            ...roomInfo,
            mainRoomInfo: isMain
              ? {
                  id: data.roomId,
                  roomId: data.roomId,
                  showRoomId: data.showRoomId,
                  roomName: data.roomName,
                  totalNum: data.audienceNum,
                  logoUrl: data.logoUrl,
                  typeId: data.typeId,
                  isAllBanned: data.isAllBanned === 0 || data.isAllBanned === 1 ? true : false,
                  imId: data.imId,
                  gameName: data.gameName,
                  serverName: data.serverName,
                  typeName: data.typeName
                }
              : roomInfo.mainRoomInfo,
            mainRoomId: isMain ? data.roomId : roomInfo.mainRoomId,
            roomId: data.roomId,
            roleId: data.roleId === null || undefined ? 3 : data.roleId,
            modelType: data.modelType,
            roomNum: data.audienceNum,
            micStatus: data.micStatus,
            isMic: data.onMic,
            isAllBanned: data.isAllBanned === 0 || data.isAllBanned === 1 ? true : false,
            banMsg: data.isBanned,
            roomDetail: data,
            hxRoomId: Number(data.imId),
            chatInterval: Number(data.chatInterval || 0),
            tourBanChat: data.tourBanChat ? JSON.parse(data.tourBanChat) : false,
            svip_effect: data.svip_effect,
            userId: data.userId,
            ctime: data.systemTime, // 进入房间时间
            user_96show: data?.user_96show
          })
        );
        const kickInfo = VoiceFn.getLocalInfo('kickInfo');
        const list = kickInfo && kickInfo.list ? kickInfo.list : [];
        for (let i = list.length - 1; i >= 0; i--) {
          if (list[i].roomId === roomId) {
            if (list[i].state === 1) {
              list.splice(i, 1);
              store.dispatch(
                setKickInfo({
                  ...kickInfo,
                  isShow: false,
                  roomId,
                  list
                })
              );
            }
            break;
          }
        }
      } else if (res.data.code === 98002) {
        const kickInfo = VoiceFn.getLocalInfo('kickInfo');
        store.dispatch(
          setKickInfo({
            ...kickInfo,
            isShow: true,
            isReload: Date.now(),
            banRoomMsg: res.data.msg
          })
        );
        VoiceFn.cancelLoading(0);
      } else if (res.data.code === 98005) {
        const kickInfo = VoiceFn.getLocalInfo('kickInfo');
        store.dispatch(
          setKickInfo({
            ...kickInfo,
            isShow: true,
            isReload: Date.now(),
            banRoomMsg: res.data.msg
          })
        );
        VoiceFn.cancelLoading(0);
      } else if (res.data.code === 98008) {
        const kickInfo = VoiceFn.getLocalInfo('kickInfo');
        const list = kickInfo && kickInfo.list ? kickInfo.list : [];
        let bol = true;
        for (let i = list.length - 1; i >= 0; i--) {
          if (list[i].roomId === roomId) {
            bol = false;
            store.dispatch(
              setKickInfo({
                ...kickInfo,
                isShow: true,
                roomId,
                isReload: Date.now()
              })
            );
            break;
          }
        }
        if (bol) {
          message.info(res.data.msg);
        }
        VoiceFn.cancelLoading(0);
      } else {
        message.info(res.data.msg);
      }
    } catch (error) {
      console.log(error);
    }
    VoiceFn.cancelLoading(0);
  },
  resetInfo: async (isExist?: boolean) => {
    try {
      toLogout();
    } catch (error) {
      console.log(error);
    }
    const leftInfo = VoiceFn.getLocalInfo('leftInfo');
    const roomInfo = VoiceFn.getLocalInfo('roomInfo');
    store.dispatch(
      setMsgInfo({
        msgItem: undefined
      })
    );
    if (!isExist) {
      store.dispatch(
        setLeftInfo({
          ...leftInfo,
          showComId: 'voiceHall'
        })
      );
    }
    store.dispatch(
      setOnlineInfo({
        list: [],
        state: 0,
        userId: 0,
        roomId: 0,
        roomName: '',
        roomTime: 0
      })
    );
    // 退出重置
    store.dispatch(
      setRoomInfo({
        ...roomInfo,
        mainRoomInfo: {
          roomId: 0,
          showRoomId: 0,
          roomName: '',
          totalNum: 0,
          logoUrl: '',
          typeId: '',
          isAllBanned: false,
          imId: 0,
          gameName: '',
          serverName: '',
          typeName: ''
        },
        mainRoomId: 0,
        roomId: 0,
        roleId: 0,
        modelType: 1,
        roomNum: 0,
        diffTime: 0,
        micReload: 0,
        micStatus: false,
        isMic: true,
        isAllBanned: false,
        banMsg: false,
        roomDetail: undefined,
        hxRoomId: 0,
        chatInterval: 0,
        tourBanChat: false,
        svip_effect: undefined,
        userId: 0,
        ctime: 0,
        user_96show: undefined
      })
    );
  },
  toLeaveRoom: async (isExist?: boolean, livePlatform?: string) => {
    destroyRtc();
    try {
      const roomInfo = VoiceFn.getLocalInfo('roomInfo');
      const info: any = LocalStore.getValue('React-ant-Admin-user');
      const roomId = roomInfo.roomId;
      const kickInfo = VoiceFn.getLocalInfo('kickInfo');
      const list = kickInfo && kickInfo.list ? kickInfo.list : [];
      for (let i = list.length - 1; i >= 0; i--) {
        if (list[i].roomId === roomId) {
          if (list[i].state === 0) {
            list[i].state = 1;
            store.dispatch(
              setKickInfo({
                ...kickInfo,
                isShow: false,
                list
              })
            );
          }
          break;
        }
      }
      const joinConflict = localStorage.getItem('BOXANDSHOW');
      await leaveroom({
        roomId,
        fromType: 0,
        userId: info.userinfo.id,
        live_platform: livePlatform,
        quitType: joinConflict ? JSON.parse(joinConflict) : ''
      });
      VoiceFn.removeVoiceLivePlatform();
    } catch (error) {
      console.log(error);
    }
    VoiceFn.resetInfo(isExist);
  },
  toEnterSubRoom: async (roomId: number, livePlatform?: string) => {
    try {
      const leftInfo = VoiceFn.getLocalInfo('leftInfo');
      const roomInfo = VoiceFn.getLocalInfo('roomInfo');
      const info: any = LocalStore.getValue('React-ant-Admin-user');
      const objInfo: any = {
        roomId,
        fromType: 3, // 0盒子/1游戏sdk/2临时组队/3pc子房间
        userId: info.userinfo.id,
        live_platform: livePlatform
      };
      const res: any = await joinroom(objInfo);
      if (res.code === 200) {
        VoiceFn.setVoiceLivePlatform(livePlatform);
        const data = res.data;
        const mianRoomInfo = res.data.boxRoomDetail;
        store.dispatch(
          setLeftInfo({
            ...leftInfo,
            showComId: 'myRoom',
            reloadTime: Date.now()
          })
        );
        store.dispatch(
          setRoomInfo({
            ...roomInfo,
            mainRoomInfo: {
              id: mianRoomInfo.roomId,
              roomId: mianRoomInfo.roomId,
              showRoomId: mianRoomInfo.showRoomId,
              roomName: mianRoomInfo.roomName,
              totalNum: mianRoomInfo.audienceNum,
              logoUrl: mianRoomInfo.logoUrl,
              typeId: mianRoomInfo.typeId,
              isAllBanned: mianRoomInfo.isAllBanned === 0 || mianRoomInfo.isAllBanned === 1 ? true : false,
              imId: mianRoomInfo.imId,
              gameName: mianRoomInfo.gameName,
              serverName: mianRoomInfo.serverName,
              typeName: mianRoomInfo.typeName
            },
            mainRoomId: mianRoomInfo.roomId,
            roomId: data.roomId,
            roleId: data.roleId === null || undefined ? 3 : data.roleId,
            modelType: data.modelType,
            roomNum: data.audienceNum,
            micStatus: data.micStatus,
            isMic: data.onMic,
            isAllBanned: data.isAllBanned === 0 || data.isAllBanned === 1 ? true : false,
            banMsg: data.isBanned,
            roomDetail: data,
            hxRoomId: Number(data.imId),
            chatInterval: Number(data.chatInterval || 0),
            tourBanChat: data.tourBanChat ? JSON.parse(data.tourBanChat) : false,
            svip_effect: data.svip_effect,
            userId: data.userId,
            ctime: data.systemTime, // 进入房间时间
            user_96show: data?.user_96show
          })
        );
        const kickInfo = VoiceFn.getLocalInfo('kickInfo');
        const list = kickInfo && kickInfo.list ? kickInfo.list : [];
        for (let i = list.length - 1; i >= 0; i--) {
          if (list[i].roomId === roomId) {
            if (list[i].state === 1) {
              list.splice(i, 1);
              store.dispatch(
                setKickInfo({
                  ...kickInfo,
                  isShow: false,
                  roomId,
                  list
                })
              );
            }
            break;
          }
        }
      } else if (res.data.code === 98002) {
        const kickInfo = VoiceFn.getLocalInfo('kickInfo');
        store.dispatch(
          setKickInfo({
            ...kickInfo,
            isShow: true,
            isReload: Date.now(),
            banRoomMsg: res.data.msg
          })
        );
        VoiceFn.cancelLoading(0);
      } else if (res.data.code === 98005) {
        const kickInfo = VoiceFn.getLocalInfo('kickInfo');
        store.dispatch(
          setKickInfo({
            ...kickInfo,
            isShow: true,
            isReload: Date.now(),
            banRoomMsg: res.data.msg
          })
        );
        VoiceFn.cancelLoading(0);
      } else if (res.data.code === 98008) {
        const kickInfo = VoiceFn.getLocalInfo('kickInfo');
        const list = kickInfo && kickInfo.list ? kickInfo.list : [];
        let bol = true;
        for (let i = list.length - 1; i >= 0; i--) {
          if (list[i].roomId === roomId) {
            bol = false;
            store.dispatch(
              setKickInfo({
                ...kickInfo,
                isShow: true,
                roomId,
                isReload: Date.now()
              })
            );
            break;
          }
        }
        if (bol) {
          message.info(res.data.msg);
        }
        VoiceFn.cancelLoading(0);
      } else if (res.data.code === 98207) {
        store.dispatch(
          setLeftInfo({
            ...leftInfo,
            showComId: 'voiceHall'
          })
        );
        VoiceFn.cancelLoading(0);
        const validateInfo = VoiceFn.getLocalInfo('validateInfo');
        store.dispatch(
          setValidateInfo({
            ...validateInfo,
            livePlatform,
            roomId
          })
        );
      } else {
        message.info(res.data.msg);
      }
    } catch (error) {
      console.log(error);
      VoiceFn.cancelLoading(0);
    }
  },
  toEnterVoiceLiveRoom: async (roomId: number, isMain: boolean, noCheck?: boolean, livePlatform?: string) => {
    VoiceFn.cancelLoading(Date.now());
    roomId = typeof roomId === 'number' ? roomId : Number(roomId);
    const info: any = LocalStore.getValue('React-ant-Admin-user');
    LocalStore.setValue('VOICE_REQUEST_ROOMMAIN', isMain ? 1 : 2);
    const { data } = await getRoomDetail({
      roomId,
      fromType: 0,
      userId: info.userinfo.id,
      live_platform: livePlatform
    });
    const roomInfo = VoiceFn.getLocalInfo('roomInfo');
    store.dispatch(
      setMsgInfo({
        msgItem: undefined
      })
    );
    if (roomInfo && roomInfo.mainRoomId && roomInfo.roomId) {
      if (roomInfo.roomId === roomId) {
        const leftInfo = VoiceFn.getLocalInfo('leftInfo');
        store.dispatch(
          setLeftInfo({
            ...leftInfo,
            showComId: 'myRoom'
          })
        );
        VoiceFn.cancelLoading(0);
        return;
      }
      const mianRoomInfo = data.boxRoomDetail;
      if (mianRoomInfo && roomInfo.mainRoomId === mianRoomInfo.roomId) {
        const leftInfo = VoiceFn.getLocalInfo('leftInfo');
        store.dispatch(
          setLeftInfo({
            ...leftInfo,
            showComId: 'myRoom'
          })
        );
        (window as any).userChangeRoom({
          id: roomId,
          lockFlag: data.roomPassword ? true : false,
          live_platform: livePlatform
        });
        return;
      }
      // 进入主房间 - 主房间相同
      if (isMain && roomInfo.mainRoomId === roomId) {
        const leftInfo = VoiceFn.getLocalInfo('leftInfo');
        store.dispatch(
          setLeftInfo({
            ...leftInfo,
            showComId: 'myRoom'
          })
        );
        try {
          const joinConflict = localStorage.getItem('BOXANDSHOW');
          await leaveroom({
            fromType: 0,
            roomId: roomInfo.roomId,
            userId: info.userinfo.id,
            live_platform: livePlatform,
            quitType: joinConflict ? JSON.parse(joinConflict) : ''
          });
          try {
            await joinroom({
              roomId,
              fromType: 0,
              userId: info.userinfo.id,
              live_platform: livePlatform
            });
            VoiceFn.setVoiceLivePlatform(livePlatform);
            store.dispatch(
              setRoomInfo({
                ...roomInfo,
                mainRoomInfo: isMain
                  ? {
                      id: data.roomId,
                      roomId: data.roomId,
                      showRoomId: data.showRoomId,
                      roomName: data.roomName,
                      totalNum: data.audienceNum,
                      logoUrl: data.logoUrl,
                      typeId: data.typeId,
                      isAllBanned: data.isAllBanned === 0 || data.isAllBanned === 1 ? true : false,
                      imId: data.imId,
                      gameName: data.gameName,
                      serverName: data.serverName,
                      typeName: data.typeName
                    }
                  : roomInfo.mainRoomInfo,
                mainRoomId: isMain ? data.roomId : roomInfo.mainRoomId,
                roomId: data.roomId,
                roleId: data.roleId === null || undefined ? 3 : data.roleId,
                modelType: data.modelType,
                roomNum: data.audienceNum,
                micStatus: data.micStatus,
                isMic: data.onMic,
                isAllBanned: data.isAllBanned === 0 || data.isAllBanned === 1 ? true : false,
                banMsg: data.isBanned,
                roomDetail: data,
                hxRoomId: Number(data.imId),
                chatInterval: Number(data.chatInterval || 0),
                tourBanChat: data.tourBanChat ? JSON.parse(data.tourBanChat) : false,
                svip_effect: data.svip_effect,
                userId: data.userId,
                ctime: data.systemTime, // 进入房间时间
                user_96show: data?.user_96show
              })
            );
            VoiceFn.cancelLoading(0);
          } catch (error) {
            console.log('加入房间失败', error);
            VoiceFn.cancelLoading(0);
          }
        } catch (error) {
          console.log('离开房间失败', error);
          VoiceFn.cancelLoading(0);
        }
        return;
      }
      // 进入主房间 - 主房间不相同
      if (isMain) {
        VoiceFn.toEnterRoom(roomId, isMain, false, livePlatform);
        return;
      }
      if (!noCheck && data.roomPassword) {
        VoiceFn.cancelLoading(0);
        const validateInfo = VoiceFn.getLocalInfo('validateInfo');
        store.dispatch(
          setValidateInfo({
            ...validateInfo,
            roomId,
            livePlatform: VoiceFn.resolveVoiceLivePlatform(livePlatform)
          })
        );
        return;
      }
      const leftInfo = VoiceFn.getLocalInfo('leftInfo');
      store.dispatch(
        setLeftInfo({
          ...leftInfo,
          showComId: 'voiceHall'
        })
      );
      VoiceFn.toLeaveRoom(true, livePlatform);
      setTimeout(() => {
        VoiceFn.toEnterSubRoom(roomId, livePlatform);
      }, 500);
      return;
    }
    if (isMain) {
      VoiceFn.toEnterRoom(roomId, isMain, false, livePlatform);
      return;
    }
    if (!noCheck && data.roomPassword) {
      VoiceFn.cancelLoading(0);
      const validateInfo = VoiceFn.getLocalInfo('validateInfo');
      store.dispatch(
        setValidateInfo({
          ...validateInfo,
          roomId,
          livePlatform: VoiceFn.resolveVoiceLivePlatform(livePlatform)
        })
      );
      return;
    }
    VoiceFn.toEnterSubRoom(roomId, livePlatform);
  },
  toVoiceLiveRoomTransfer: async ({ roomId, isMain, noCheck, livePlatform, collectType }: NewEnterVoiceRoomParams) => {
    if (collectType) {
      LocalStore.setValue('collectType', collectType);
    } else {
      LocalStore.removeValue('collectType');
    }
    VoiceFn.toEnterVoiceLiveRoom(roomId, isMain ?? false, noCheck, VoiceFn.resolveVoiceLivePlatform(livePlatform));
  },
  searchVoiceRoomInfo: async (roomId: number, livePlatform?: string) => {
    const newLivePlatform = VoiceFn.resolveVoiceLivePlatform(livePlatform);
    const { data } = await findRandomLiveRoom({
      roomId,
      live_platform: newLivePlatform
    });
    VoiceFn.toEnterVoiceLiveRoom(data.roomId, data.roomType === 0 ? true : false, true, newLivePlatform);
  }
};

export default VoiceFn;
